import styled, { device, color } from '@styled'
import { Col } from '@ui/wrapper'

export const SectionWrapper = styled.section`
  padding-block-start: 60px;
  padding-block-end: 50px;
  ${color}
`

export const StyledText = styled.div`
  margin-block-start: 15px;
  margin-block-end: 15px !important;
  font-size: 18px;
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
  b {
    font-weight: 700;
  }
`

export const BorderCol = styled(Col)`
  ${device.small} {
    border-right: 0px solid lightgrey;
  }
  ${device.large} {
    border-right: 1px solid lightgrey;
  }
`

export const StyledImage = styled.div`
  margin-inline-start: 10px;
  margin-inline-end: 10px;
  ${device.small} {
    margin-inline-start: 34px;
    margin-inline-end: 34px;
  }
`
